import { FormationTheme, Shirt } from '../types';
import ShirtRed from '../shirts/shirt-red.png';
import ShirtBlue from '../shirts/shirt-blue.png';
import ShirtOrange from '../shirts/shirt-orange.png';
import ShirtBarca from '../shirts/shirt-barca.png';
import ShirtArgentina from '../shirts/shirt-argentina.png';
import ShirtPsg from '../shirts/shirt-psg.png';
import ShirtArsenal from '../shirts/shirt-arsenal.png';
import ShirtReal from '../shirts/shirt-real.png';
import ShirtInter from '../shirts/shirt-inter.png';
import ShirtYellow from '../shirts/shirt-yellow.png';
import ShirtDarkBlue from '../shirts/shirt-darkblue.png';
import ShirtBlue2 from '../shirts/shirt-blue2.png';
import ShirtSunderland from '../shirts/shirt-sunderland.png';

export const shirts: Shirt[] = [
  {
    img: ShirtBarca,
    theme: FormationTheme.ShirtBarca,
    textColor: '#ffff8d',
    textColorDragOver: '#fff',
  },
  {
    img: ShirtOrange,
    theme: FormationTheme.ShirtOrange,
    textColor: '#000',
    textColorDragOver: '#fff',
  },
  {
    img: ShirtRed,
    theme: FormationTheme.ShirtRed,
    textColor: '#ffff8d',
    textColorDragOver: '#000',
  },
  {
    img: ShirtBlue,
    theme: FormationTheme.ShirtBlue,
    textColor: '#000',
    textColorDragOver: 'red',
  },
  {
    img: ShirtPsg,
    theme: FormationTheme.ShirtPsg,
    textColor: '#fff',
    textColorDragOver: 'yellow',
  },
  {
    img: ShirtArgentina,
    theme: FormationTheme.ShirtArgentina,
    textColor: '#000',
    textColorDragOver: 'yellow',
  },
  {
    img: ShirtArsenal,
    theme: FormationTheme.ShirtArsenal,
    textColor: '#fff',
    textColorDragOver: '#000',
  },
  {
    img: ShirtInter,
    theme: FormationTheme.ShirtInter,
    textColor: '#fff',
    textColorDragOver: 'yellow',
  },
  {
    img: ShirtReal,
    theme: FormationTheme.ShirtReal,
    textColor: '#000',
    textColorDragOver: 'red',
  },
  {
    img: ShirtDarkBlue,
    theme: FormationTheme.ShirtDarkBlue,
    textColor: '#fff',
    textColorDragOver: 'yellow',
  },
  {
    img: ShirtYellow,
    theme: FormationTheme.ShirtYellow,
    textColor: '#000',
    textColorDragOver: 'red',
  },
  {
    img: ShirtBlue2,
    theme: FormationTheme.ShirtBlue2,
    textColor: '#fff',
    textColorDragOver: 'yellow',
  },
  {
    img: ShirtSunderland,
    theme: FormationTheme.ShirtSunderland,
    textColor: '#000',
    textColorDragOver: 'red',
  },
];
